import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Apply from "./pages/Apply";
import Dashboard from "./pages/Dashboard";
import Scanner from "./pages/Scanner";
import Inventory from "./pages/Inventory";
import ChatbotPage from "./pages/ChatbotPage";
import Leads from "./pages/Leads";
import SalesKit from "./pages/SalesKit";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AppLayout from "./components/AppLayout";
import AdminLayout from "./components/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import AdminApplications from "./pages/admin/AdminApplications";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminBlogEditor from "./pages/admin/AdminBlogEditor";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminSubscriptions from "./pages/admin/AdminSubscriptions";
import AdminFinance from "./pages/admin/AdminFinance";
import AdminMarketing from "./pages/admin/AdminMarketing";
import { isAuthed, getUser } from "./lib/nurseryApi";

const Protected = ({ children }) => (isAuthed() ? children : <Navigate to="/login" replace />);
const AdminOnly = ({ children }) => {
  if (!isAuthed()) return <Navigate to="/login" replace />;
  const u = getUser();
  if (!u?.is_admin) return <Navigate to="/app/dashboard" replace />;
  return children;
};

const Wrapped = ({ children }) => (
  <Protected>
    <AppLayout>{children}</AppLayout>
  </Protected>
);

const AdminWrapped = ({ children }) => (
  <AdminOnly>
    <AdminLayout>{children}</AdminLayout>
  </AdminOnly>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/login" element={<Login />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/register" element={<Navigate to="/apply" replace />} />
        <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/app/dashboard" element={<Wrapped><Dashboard /></Wrapped>} />
        <Route path="/app/scanner" element={<Wrapped><Scanner /></Wrapped>} />
        <Route path="/app/inventory" element={<Wrapped><Inventory /></Wrapped>} />
        <Route path="/app/chatbot" element={<Wrapped><ChatbotPage /></Wrapped>} />
        <Route path="/app/leads" element={<Wrapped><Leads /></Wrapped>} />
        <Route path="/app/sales-kit" element={<Wrapped><SalesKit /></Wrapped>} />
        <Route path="/admin" element={<AdminWrapped><AdminOverview /></AdminWrapped>} />
        <Route path="/admin/applications" element={<AdminWrapped><AdminApplications /></AdminWrapped>} />
        <Route path="/admin/users" element={<AdminWrapped><AdminUsers /></AdminWrapped>} />
        <Route path="/admin/users/:uid" element={<AdminWrapped><AdminUserDetail /></AdminWrapped>} />
        <Route path="/admin/blog" element={<AdminWrapped><AdminBlog /></AdminWrapped>} />
        <Route path="/admin/blog/:id" element={<AdminWrapped><AdminBlogEditor /></AdminWrapped>} />
        <Route path="/admin/leads" element={<AdminWrapped><AdminLeads /></AdminWrapped>} />
        <Route path="/admin/subscriptions" element={<AdminWrapped><AdminSubscriptions /></AdminWrapped>} />
        <Route path="/admin/finance" element={<AdminWrapped><AdminFinance /></AdminWrapped>} />
        <Route path="/admin/marketing" element={<AdminWrapped><AdminMarketing /></AdminWrapped>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
